// extracted by mini-css-extract-plugin
export default {"root":"Wrapper-module__root___Hjbtm"};